import { Institution } from '../institution'

class Speaker {
  constructor(options = {}) {
    options = options || {}
    this.id = options.id
    this.barcode = options.barcode || options.eventRegistrationCode
    this.biography = options.biography || []
    this.code = options.code || options.eventRegistrationCode
    this.country = options.country || options._country
    this.displayName = options.displayName
    this.email = options.email
    this.eventShortCode = options.eventShortCode
    this.firstName = options.firstName
    this.gender = options.gender
    this.imageUrl = options.imageUrl
    this.institution = Institution.init(options.institution)
    this.lastName = options.lastName
    this.middleName = options.middleName
    this.registrationId = options.registrationId || options.id
    this.subspecialties = options.subspecialties || []
    this.title = options.title || options.prefix
  }

  // Class methods
  static init(options) {
    if (options instanceof Speaker) {
      return options
    }
    const instance = new Speaker(options)
    return instance.isValid ? instance : null
  }
  static initFromArray(arr) {
    if (Array.isArray(arr)) {
      return arr.map(this.init)
    }
    return []
  }
  static initOnlyValidFromArray(arr = []) {
    return this.initFromArray(arr).filter((i) => i)
  }

  // getters
  get isValid() {
    return !!this.code
  }

}

export default {
  Speaker
}
export {
  Speaker
}
